import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";

const StaticPagesActionBtns = ({absolute_url, def_image_logo}) => {
  const dispatch = useDispatch();

  const showImage = (src) => {
    dispatch(openModal({
      modalType: 'show-image',
      modalProps: {
        src,
      }
    }))
  }

  return (
    <div className='flex'>
      <a target='_blank' className={'mr-3'} id="tooltip" data-tip="Go to page" href={absolute_url}>
        <FontAwesomeIcon
          color={'blue'}
          size={'lg'}
          icon={solid('arrow-up-right-from-square')}/>
      </a>
      {
        !!def_image_logo && (
          <button onClick={() => showImage(def_image_logo)} className='mr-3' data-tip="Show image for computers">
            <FontAwesomeIcon
              color={'blue'}
              size={'lg'}
              icon={solid('desktop')}/>
          </button>)
      }
    </div>
  );
};

export default StaticPagesActionBtns;
